"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchResponse = exports.TaxonSearchExportInfo = exports.SearchResultsExportInfo = exports.TaxonCriteria = exports.SearchRefinementViewInfo = exports.SearchFilterModel = exports.SearchFilterGroupModel = exports.OrderingOption = exports.SearchViewType = exports.SavedSearchQueryViewModel = exports.ProductPageNavigationDto = exports.ITileDto = exports.ProductPageDto = exports.ProductDropdownModel = exports.ProductModel = exports.PortalPropertyDto = exports.PortalConfigurationDto = exports.PortalDocumentContext = exports.ParagraphInTime = exports.Law = exports.ParagraphZoomQueryModel = exports.ConsolidationConfigModel = exports.HistoryTimelineConfigurationModel = exports.AboutDocumentModel = exports.DocumentPageConfigurationModel = exports.SearchTermsAnalyzerModel = exports.SearchPageConfigurationModel = exports.MergeSectionViewModel = exports.MergeDocumentViewModel = exports.TileDto = exports.PortalLocalizationModel = exports.DocumentLinkInfo = exports.DocumentViewInfo = exports.CreateOrUpdateDocumentVersionSubscriptionModel = exports.DocumentVersionSubscriptionInfo = exports.DocumentModel = exports.DocumentSubscriptionMarkModel = exports.DocumentSubscriptionMarkCreateModel = exports.ChangedDocumentSubscriptionMarkDeltaItem = exports.DocumentSubscriptionMarkDeltaItem = exports.DocumentSubscriptionMarksDelta = exports.DocumentSubscriptionModel = exports.DocumentSectionTreeDto = exports.DocumentSectionDto = exports.BookmarkDto = exports.RelatedDocumentDto = exports.RelationGroupDto = exports.DocumentRelationsLocationsModel = exports.RelatedTargetDocumentFieldSetsDto = exports.DocumentRelationNodeDto = exports.RelatedSourceDocumentFieldSetModel = exports.RelatedTargetDocumentFieldSetModel = exports.DocumentFamilyPropertyDto = exports.DocumentFieldModel = exports.AboutDocumentFamilyDto = exports.AnnotationRequest = exports.PrintRequestModel = exports.DocumentPropertyModel = exports.TocEntry = exports.Toc = exports.DocumentTaxonDto = exports.DocumentPropertyDto = exports.DocumentDto = exports.SupplementalPartInfo = exports.PrimaryPartInfo = exports.VariantInfo = exports.AttachmentDto = exports.TaxonReferenceInfo = exports.SchemaDrivenPropertyInfo = exports.DocumentInfo = exports.AssetCollectionReleaseArtifactInfo = exports.AssetItemInfo = exports.AssetFolderInfo = exports.AssetCollectionReleaseInfo = exports.AssetCollectionTemplateViewModel = exports.AssetItemTargetLocation = exports.NodeInfo = exports.CreateAssetCollectionFromPdfQuoteRequest = exports.GeometricSelectionModel = exports.FlowQuoteModel = exports.CreateAssetCollectionFromQuoteRequest = exports.AssetCollectionDocumentAdditionModel = exports.CreateAssetCollectionRequest = exports.AddMembersRequest = exports.PermissionViewModel = exports.AssetCollectionMemberViewModel = exports.AssetCollectionViewModel = exports.PdfNewAnnotationDTO = exports.PdfAnnotationModel = exports.HtmlAnnotationModel = exports.HtmlNewAnnotationDTO = exports.AnnotationModel = exports.AnnotationTargetInfo = exports.ChatResponseSourceDto = exports.ChatMessageDto = exports.StreamResponseDto = exports.PromptProfileDto = exports.SearchProfileDto = exports.AiCompletionOptionsDto = exports.AiCompletionNamedConfigurationDto = void 0;
exports.PathsJ2FataApiPortalsPortalidAssetcollectionsAssetcollectionidFilePostRequestbodyContentMultipartFormDataSchema = exports.UserProfileDto = exports.FeatureViewModel = exports.UserViewModel = exports.LegalTimelineNodeDto = exports.DocumentHistoryTimelineNodeLeafDto = exports.DocumentHistoryTimelineNodeDto = exports.DocumentHistoryTimelineDto = exports.TimelineStatusDto = exports.TicketInfo = exports.TaxonPathInfo = exports.Taxon = exports.Taxonomy = exports.RhinestoneThemeDto = exports.SpaConfigDto = exports.SearchSuggestionsProviderModel = exports.SearchSubscriptionInfo = exports.SearchPreviewDto = exports.TaxonCountInfo = exports.SearchResultTaxonomyMatchInfo = void 0;

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
var AiCompletionNamedConfigurationDto = {
  type: {
    name: "Composite",
    className: "AiCompletionNamedConfigurationDto",
    modelProperties: {
      key: {
        serializedName: "key",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      portalUrl: {
        serializedName: "portalUrl",
        required: true,
        type: {
          name: "String"
        }
      },
      options: {
        serializedName: "options",
        type: {
          name: "Composite",
          className: "AiCompletionOptionsDto"
        }
      }
    }
  }
};
exports.AiCompletionNamedConfigurationDto = AiCompletionNamedConfigurationDto;
var AiCompletionOptionsDto = {
  type: {
    name: "Composite",
    className: "AiCompletionOptionsDto",
    modelProperties: {
      searchProfile: {
        serializedName: "searchProfile",
        type: {
          name: "Composite",
          className: "SearchProfileDto"
        }
      },
      promptProfile: {
        serializedName: "promptProfile",
        type: {
          name: "Composite",
          className: "PromptProfileDto"
        }
      }
    }
  }
};
exports.AiCompletionOptionsDto = AiCompletionOptionsDto;
var SearchProfileDto = {
  type: {
    name: "Composite",
    className: "SearchProfileDto",
    modelProperties: {
      indexName: {
        serializedName: "indexName",
        required: true,
        type: {
          name: "String"
        }
      },
      embeddingModel: {
        serializedName: "embeddingModel",
        required: true,
        type: {
          name: "String"
        }
      },
      vectorField: {
        serializedName: "vectorField",
        required: true,
        type: {
          name: "String"
        }
      },
      useHybridSearch: {
        serializedName: "useHybridSearch",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      semanticConfigurationName: {
        serializedName: "semanticConfigurationName",
        required: true,
        type: {
          name: "String"
        }
      },
      minimumScore: {
        serializedName: "minimumScore",
        required: true,
        type: {
          name: "Number"
        }
      },
      minimumRerankerScore: {
        serializedName: "minimumRerankerScore",
        required: true,
        type: {
          name: "Number"
        }
      },
      maxResults: {
        serializedName: "maxResults",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.SearchProfileDto = SearchProfileDto;
var PromptProfileDto = {
  type: {
    name: "Composite",
    className: "PromptProfileDto",
    modelProperties: {
      systemPrompt: {
        serializedName: "systemPrompt",
        required: true,
        type: {
          name: "String"
        }
      },
      seed: {
        serializedName: "seed",
        required: true,
        type: {
          name: "Number"
        }
      },
      maxTokens: {
        serializedName: "maxTokens",
        required: true,
        type: {
          name: "Number"
        }
      },
      temperature: {
        serializedName: "temperature",
        required: true,
        type: {
          name: "Number"
        }
      },
      numberOfSourcesToInclude: {
        serializedName: "numberOfSourcesToInclude",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.PromptProfileDto = PromptProfileDto;
var StreamResponseDto = {
  type: {
    name: "Composite",
    className: "StreamResponseDto",
    modelProperties: {
      chatMessages: {
        serializedName: "chatMessages",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ChatMessageDto"
            }
          }
        }
      },
      chatResponseSource: {
        serializedName: "chatResponseSource",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ChatResponseSourceDto"
            }
          }
        }
      }
    }
  }
};
exports.StreamResponseDto = StreamResponseDto;
var ChatMessageDto = {
  type: {
    name: "Composite",
    className: "ChatMessageDto",
    modelProperties: {
      role: {
        serializedName: "role",
        required: true,
        type: {
          name: "String"
        }
      },
      content: {
        serializedName: "content",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.ChatMessageDto = ChatMessageDto;
var ChatResponseSourceDto = {
  type: {
    name: "Composite",
    className: "ChatResponseSourceDto",
    modelProperties: {
      index: {
        serializedName: "index",
        required: true,
        type: {
          name: "Number"
        }
      },
      documentTitle: {
        serializedName: "documentTitle",
        required: true,
        type: {
          name: "String"
        }
      },
      hiveId: {
        serializedName: "hiveId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      fullName: {
        serializedName: "fullName",
        required: true,
        type: {
          name: "String"
        }
      },
      url: {
        serializedName: "url",
        required: true,
        type: {
          name: "String"
        }
      },
      content: {
        serializedName: "content",
        required: true,
        type: {
          name: "String"
        }
      },
      sliceBookmark: {
        serializedName: "sliceBookmark",
        required: true,
        type: {
          name: "String"
        }
      },
      sliceTitle: {
        serializedName: "sliceTitle",
        required: true,
        type: {
          name: "String"
        }
      },
      score: {
        serializedName: "score",
        required: true,
        type: {
          name: "Number"
        }
      },
      similarity: {
        serializedName: "similarity",
        required: true,
        type: {
          name: "Number"
        }
      },
      semanticRerankerScore: {
        serializedName: "semanticRerankerScore",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.ChatResponseSourceDto = ChatResponseSourceDto;
var AnnotationTargetInfo = {
  type: {
    name: "Composite",
    className: "AnnotationTargetInfo",
    modelProperties: {
      annotationTargetId: {
        serializedName: "annotationTargetId",
        required: true,
        type: {
          name: "Uuid"
        }
      }
    }
  }
};
exports.AnnotationTargetInfo = AnnotationTargetInfo;
var AnnotationModel = {
  type: {
    name: "Composite",
    className: "AnnotationModel",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      comment: {
        serializedName: "comment",
        required: true,
        type: {
          name: "String"
        }
      },
      userName: {
        serializedName: "userName",
        required: true,
        type: {
          name: "String"
        }
      },
      createdAt: {
        serializedName: "createdAt",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      updatedAt: {
        serializedName: "updatedAt",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      createdAtDisplayString: {
        serializedName: "createdAtDisplayString",
        readOnly: true,
        nullable: true,
        type: {
          name: "String"
        }
      },
      updatedAtDisplayString: {
        serializedName: "updatedAtDisplayString",
        readOnly: true,
        nullable: true,
        type: {
          name: "String"
        }
      },
      hasWriteAccess: {
        serializedName: "hasWriteAccess",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      isOrphan: {
        serializedName: "isOrphan",
        required: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};
exports.AnnotationModel = AnnotationModel;
var HtmlNewAnnotationDTO = {
  type: {
    name: "Composite",
    className: "HtmlNewAnnotationDTO",
    modelProperties: {
      comment: {
        serializedName: "comment",
        required: true,
        type: {
          name: "String"
        }
      },
      endOffset: {
        serializedName: "endOffset",
        required: true,
        type: {
          name: "Number"
        }
      },
      startOffset: {
        serializedName: "startOffset",
        required: true,
        type: {
          name: "Number"
        }
      },
      length: {
        serializedName: "length",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.HtmlNewAnnotationDTO = HtmlNewAnnotationDTO;
var HtmlAnnotationModel = {
  type: {
    name: "Composite",
    className: "HtmlAnnotationModel",
    modelProperties: {
      endOffset: {
        serializedName: "endOffset",
        required: true,
        type: {
          name: "Number"
        }
      },
      startOffset: {
        serializedName: "startOffset",
        required: true,
        type: {
          name: "Number"
        }
      },
      length: {
        serializedName: "length",
        required: true,
        type: {
          name: "Number"
        }
      },
      trailingAnnotationText: {
        serializedName: "trailingAnnotationText",
        nullable: true,
        type: {
          name: "String"
        }
      },
      annotatedText: {
        serializedName: "annotatedText",
        nullable: true,
        type: {
          name: "String"
        }
      },
      leadingAnnotationText: {
        serializedName: "leadingAnnotationText",
        nullable: true,
        type: {
          name: "String"
        }
      },
      sourceDocumentLink: {
        serializedName: "sourceDocumentLink",
        nullable: true,
        type: {
          name: "String"
        }
      },
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      comment: {
        serializedName: "comment",
        required: true,
        type: {
          name: "String"
        }
      },
      userName: {
        serializedName: "userName",
        required: true,
        type: {
          name: "String"
        }
      },
      createdAt: {
        serializedName: "createdAt",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      updatedAt: {
        serializedName: "updatedAt",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      createdAtDisplayString: {
        serializedName: "createdAtDisplayString",
        readOnly: true,
        nullable: true,
        type: {
          name: "String"
        }
      },
      updatedAtDisplayString: {
        serializedName: "updatedAtDisplayString",
        readOnly: true,
        nullable: true,
        type: {
          name: "String"
        }
      },
      hasWriteAccess: {
        serializedName: "hasWriteAccess",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      isOrphan: {
        serializedName: "isOrphan",
        required: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};
exports.HtmlAnnotationModel = HtmlAnnotationModel;
var PdfAnnotationModel = {
  type: {
    name: "Composite",
    className: "PdfAnnotationModel",
    modelProperties: {
      startX: {
        serializedName: "startX",
        required: true,
        type: {
          name: "Number"
        }
      },
      startY: {
        serializedName: "startY",
        required: true,
        type: {
          name: "Number"
        }
      },
      endX: {
        serializedName: "endX",
        required: true,
        type: {
          name: "Number"
        }
      },
      endY: {
        serializedName: "endY",
        required: true,
        type: {
          name: "Number"
        }
      },
      pageIndex: {
        serializedName: "pageIndex",
        required: true,
        type: {
          name: "Number"
        }
      },
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      comment: {
        serializedName: "comment",
        required: true,
        type: {
          name: "String"
        }
      },
      userName: {
        serializedName: "userName",
        required: true,
        type: {
          name: "String"
        }
      },
      createdAt: {
        serializedName: "createdAt",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      updatedAt: {
        serializedName: "updatedAt",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      createdAtDisplayString: {
        serializedName: "createdAtDisplayString",
        readOnly: true,
        nullable: true,
        type: {
          name: "String"
        }
      },
      updatedAtDisplayString: {
        serializedName: "updatedAtDisplayString",
        readOnly: true,
        nullable: true,
        type: {
          name: "String"
        }
      },
      hasWriteAccess: {
        serializedName: "hasWriteAccess",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      isOrphan: {
        serializedName: "isOrphan",
        required: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};
exports.PdfAnnotationModel = PdfAnnotationModel;
var PdfNewAnnotationDTO = {
  type: {
    name: "Composite",
    className: "PdfNewAnnotationDTO",
    modelProperties: {
      comment: {
        serializedName: "comment",
        required: true,
        type: {
          name: "String"
        }
      },
      startX: {
        serializedName: "startX",
        required: true,
        type: {
          name: "Number"
        }
      },
      startY: {
        serializedName: "startY",
        required: true,
        type: {
          name: "Number"
        }
      },
      endX: {
        serializedName: "endX",
        required: true,
        type: {
          name: "Number"
        }
      },
      endY: {
        serializedName: "endY",
        required: true,
        type: {
          name: "Number"
        }
      },
      pageIndex: {
        serializedName: "pageIndex",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.PdfNewAnnotationDTO = PdfNewAnnotationDTO;
var AssetCollectionViewModel = {
  type: {
    name: "Composite",
    className: "AssetCollectionViewModel",
    modelProperties: {
      assetCollectionId: {
        serializedName: "assetCollectionId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      accessLevel: {
        serializedName: "accessLevel",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [0, 1, 2, 4, 7]
        }
      },
      hasReadAccess: {
        serializedName: "hasReadAccess",
        readOnly: true,
        nullable: true,
        type: {
          name: "Boolean"
        }
      },
      hasWriteAccess: {
        serializedName: "hasWriteAccess",
        readOnly: true,
        nullable: true,
        type: {
          name: "Boolean"
        }
      },
      hasSecurityAccess: {
        serializedName: "hasSecurityAccess",
        readOnly: true,
        nullable: true,
        type: {
          name: "Boolean"
        }
      },
      rootFolderId: {
        serializedName: "rootFolderId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "description",
        required: true,
        type: {
          name: "String"
        }
      },
      frontPageText: {
        serializedName: "frontPageText",
        required: true,
        type: {
          name: "String"
        }
      },
      referenceNumber: {
        serializedName: "referenceNumber",
        required: true,
        type: {
          name: "String"
        }
      },
      responsibleName: {
        serializedName: "responsibleName",
        required: true,
        type: {
          name: "String"
        }
      },
      isArchived: {
        serializedName: "isArchived",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      created: {
        serializedName: "created",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      lastModified: {
        serializedName: "lastModified",
        required: true,
        type: {
          name: "DateTime"
        }
      }
    }
  }
};
exports.AssetCollectionViewModel = AssetCollectionViewModel;
var AssetCollectionMemberViewModel = {
  type: {
    name: "Composite",
    className: "AssetCollectionMemberViewModel",
    modelProperties: {
      id: {
        serializedName: "Id",
        required: true,
        type: {
          name: "String"
        }
      },
      displayName: {
        serializedName: "DisplayName",
        required: true,
        type: {
          name: "String"
        }
      },
      email: {
        serializedName: "Email",
        required: true,
        type: {
          name: "String"
        }
      },
      permissions: {
        serializedName: "Permissions",
        type: {
          name: "Composite",
          className: "PermissionViewModel"
        }
      },
      isCurrentUser: {
        serializedName: "IsCurrentUser",
        required: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};
exports.AssetCollectionMemberViewModel = AssetCollectionMemberViewModel;
var PermissionViewModel = {
  type: {
    name: "Composite",
    className: "PermissionViewModel",
    modelProperties: {
      permission: {
        serializedName: "Permission",
        required: true,
        type: {
          name: "Number"
        }
      },
      displayNameTranslationKey: {
        serializedName: "DisplayNameTranslationKey",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.PermissionViewModel = PermissionViewModel;
var AddMembersRequest = {
  type: {
    name: "Composite",
    className: "AddMembersRequest",
    modelProperties: {
      users: {
        serializedName: "Users",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Uuid"
            }
          }
        }
      },
      permissions: {
        serializedName: "Permissions",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Number"
            }
          }
        }
      }
    }
  }
};
exports.AddMembersRequest = AddMembersRequest;
var CreateAssetCollectionRequest = {
  type: {
    name: "Composite",
    className: "CreateAssetCollectionRequest",
    modelProperties: {
      title: {
        serializedName: "Title",
        required: true,
        type: {
          name: "String"
        }
      },
      referenceNumber: {
        serializedName: "ReferenceNumber",
        required: true,
        type: {
          name: "String"
        }
      },
      documents: {
        serializedName: "Documents",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssetCollectionDocumentAdditionModel"
            }
          }
        }
      }
    }
  }
};
exports.CreateAssetCollectionRequest = CreateAssetCollectionRequest;
var AssetCollectionDocumentAdditionModel = {
  type: {
    name: "Composite",
    className: "AssetCollectionDocumentAdditionModel",
    modelProperties: {
      fullName: {
        serializedName: "fullName",
        required: true,
        type: {
          name: "String"
        }
      },
      hiveId: {
        serializedName: "hiveId",
        required: true,
        type: {
          name: "String"
        }
      },
      revisionNumber: {
        serializedName: "revisionNumber",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.AssetCollectionDocumentAdditionModel = AssetCollectionDocumentAdditionModel;
var CreateAssetCollectionFromQuoteRequest = {
  type: {
    name: "Composite",
    className: "CreateAssetCollectionFromQuoteRequest",
    modelProperties: {
      title: {
        serializedName: "Title",
        required: true,
        type: {
          name: "String"
        }
      },
      referenceNumber: {
        serializedName: "ReferenceNumber",
        required: true,
        type: {
          name: "String"
        }
      },
      quote: {
        serializedName: "Quote",
        type: {
          name: "Composite",
          className: "FlowQuoteModel"
        }
      }
    }
  }
};
exports.CreateAssetCollectionFromQuoteRequest = CreateAssetCollectionFromQuoteRequest;
var FlowQuoteModel = {
  type: {
    name: "Composite",
    className: "FlowQuoteModel",
    modelProperties: {
      startOffset: {
        serializedName: "startOffset",
        required: true,
        type: {
          name: "Number"
        }
      },
      length: {
        serializedName: "length",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.FlowQuoteModel = FlowQuoteModel;
var GeometricSelectionModel = {
  type: {
    name: "Composite",
    className: "GeometricSelectionModel",
    modelProperties: {
      startX: {
        serializedName: "startX",
        required: true,
        type: {
          name: "Number"
        }
      },
      startY: {
        serializedName: "startY",
        required: true,
        type: {
          name: "Number"
        }
      },
      endX: {
        serializedName: "endX",
        required: true,
        type: {
          name: "Number"
        }
      },
      endY: {
        serializedName: "endY",
        required: true,
        type: {
          name: "Number"
        }
      },
      pageIndex: {
        serializedName: "pageIndex",
        required: true,
        type: {
          name: "Number"
        }
      },
      pageNumber: {
        serializedName: "pageNumber",
        readOnly: true,
        nullable: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.GeometricSelectionModel = GeometricSelectionModel;
var CreateAssetCollectionFromPdfQuoteRequest = {
  type: {
    name: "Composite",
    className: "CreateAssetCollectionFromPdfQuoteRequest",
    modelProperties: {
      title: {
        serializedName: "Title",
        required: true,
        type: {
          name: "String"
        }
      },
      referenceNumber: {
        serializedName: "ReferenceNumber",
        required: true,
        type: {
          name: "String"
        }
      },
      quote: {
        serializedName: "Quote",
        type: {
          name: "Composite",
          className: "GeometricSelectionModel"
        }
      }
    }
  }
};
exports.CreateAssetCollectionFromPdfQuoteRequest = CreateAssetCollectionFromPdfQuoteRequest;
var NodeInfo = {
  type: {
    name: "Composite",
    className: "NodeInfo",
    modelProperties: {
      itemId: {
        serializedName: "ItemId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      folderId: {
        serializedName: "FolderId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      itemType: {
        serializedName: "ItemType",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [0, 1, 2, 3]
        }
      },
      name: {
        serializedName: "Name",
        required: true,
        type: {
          name: "String"
        }
      },
      nodes: {
        serializedName: "Nodes",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "NodeInfo"
            }
          }
        }
      },
      lastModifiedAt: {
        serializedName: "LastModifiedAt",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      addedAt: {
        serializedName: "AddedAt",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      portalHasAccess: {
        serializedName: "PortalHasAccess",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      addedBy: {
        serializedName: "AddedBy",
        required: true,
        type: {
          name: "String"
        }
      },
      hyperlink: {
        serializedName: "Hyperlink",
        required: true,
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "Description",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.NodeInfo = NodeInfo;
var AssetItemTargetLocation = {
  type: {
    name: "Composite",
    className: "AssetItemTargetLocation",
    modelProperties: {
      folderId: {
        serializedName: "folderId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      index: {
        serializedName: "index",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.AssetItemTargetLocation = AssetItemTargetLocation;
var AssetCollectionTemplateViewModel = {
  type: {
    name: "Composite",
    className: "AssetCollectionTemplateViewModel",
    modelProperties: {
      assetCollectionTemplateId: {
        serializedName: "assetCollectionTemplateId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      rootFolderId: {
        serializedName: "rootFolderId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "description",
        required: true,
        type: {
          name: "String"
        }
      },
      frontPageText: {
        serializedName: "frontPageText",
        required: true,
        type: {
          name: "String"
        }
      },
      referenceNumber: {
        serializedName: "referenceNumber",
        required: true,
        type: {
          name: "String"
        }
      },
      responsibleName: {
        serializedName: "responsibleName",
        required: true,
        type: {
          name: "String"
        }
      },
      isArchived: {
        serializedName: "isArchived",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      created: {
        serializedName: "created",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      lastModified: {
        serializedName: "lastModified",
        required: true,
        type: {
          name: "DateTime"
        }
      }
    }
  }
};
exports.AssetCollectionTemplateViewModel = AssetCollectionTemplateViewModel;
var AssetCollectionReleaseInfo = {
  type: {
    name: "Composite",
    className: "AssetCollectionReleaseInfo",
    modelProperties: {
      assetCollectionId: {
        serializedName: "AssetCollectionId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      title: {
        serializedName: "Title",
        required: true,
        type: {
          name: "String"
        }
      },
      referenceNumber: {
        serializedName: "ReferenceNumber",
        required: true,
        type: {
          name: "String"
        }
      },
      releaseNumber: {
        serializedName: "ReleaseNumber",
        required: true,
        type: {
          name: "Number"
        }
      },
      description: {
        serializedName: "Description",
        required: true,
        type: {
          name: "String"
        }
      },
      frontPageText: {
        serializedName: "FrontPageText",
        required: true,
        type: {
          name: "String"
        }
      },
      includeSeparatorPages: {
        serializedName: "IncludeSeparatorPages",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      includeAssetCollectionAnnotations: {
        serializedName: "IncludeAssetCollectionAnnotations",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      requestedAt: {
        serializedName: "RequestedAt",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      requestedBy: {
        serializedName: "RequestedBy",
        required: true,
        type: {
          name: "String"
        }
      },
      languageCode: {
        serializedName: "LanguageCode",
        required: true,
        type: {
          name: "String"
        }
      },
      status: {
        serializedName: "Status",
        required: true,
        type: {
          name: "Number"
        }
      },
      rootFolder: {
        serializedName: "RootFolder",
        type: {
          name: "Composite",
          className: "AssetFolderInfo"
        }
      },
      artifacts: {
        serializedName: "Artifacts",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssetCollectionReleaseArtifactInfo"
            }
          }
        }
      },
      claimValue: {
        serializedName: "ClaimValue",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.AssetCollectionReleaseInfo = AssetCollectionReleaseInfo;
var AssetFolderInfo = {
  type: {
    name: "Composite",
    className: "AssetFolderInfo",
    modelProperties: {
      assetFolderId: {
        serializedName: "AssetFolderId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      items: {
        serializedName: "Items",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssetItemInfo"
            }
          }
        }
      }
    }
  }
};
exports.AssetFolderInfo = AssetFolderInfo;
var AssetItemInfo = {
  type: {
    name: "Composite",
    className: "AssetItemInfo",
    modelProperties: {
      assetItemId: {
        serializedName: "AssetItemId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      index: {
        serializedName: "Index",
        required: true,
        type: {
          name: "Number"
        }
      },
      name: {
        serializedName: "Name",
        required: true,
        type: {
          name: "String"
        }
      },
      portalHasAccess: {
        serializedName: "PortalHasAccess",
        required: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};
exports.AssetItemInfo = AssetItemInfo;
var AssetCollectionReleaseArtifactInfo = {
  type: {
    name: "Composite",
    className: "AssetCollectionReleaseArtifactInfo",
    modelProperties: {
      mimeType: {
        constraints: {
          MaxLength: 128
        },
        serializedName: "MimeType",
        required: true,
        type: {
          name: "String"
        }
      },
      artifactId: {
        serializedName: "ArtifactId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      flags: {
        serializedName: "Flags",
        required: true,
        type: {
          name: "Number"
        }
      },
      downloadUrl: {
        serializedName: "DownloadUrl",
        required: true,
        type: {
          name: "String"
        }
      },
      fileName: {
        serializedName: "FileName",
        required: true,
        type: {
          name: "String"
        }
      },
      createdAt: {
        serializedName: "CreatedAt",
        required: true,
        type: {
          name: "DateTime"
        }
      }
    }
  }
};
exports.AssetCollectionReleaseArtifactInfo = AssetCollectionReleaseArtifactInfo;
var DocumentInfo = {
  type: {
    name: "Composite",
    className: "DocumentInfo",
    modelProperties: {
      properties: {
        serializedName: "properties",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SchemaDrivenPropertyInfo"
            }
          }
        }
      },
      taxons: {
        serializedName: "taxons",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TaxonReferenceInfo"
            }
          }
        }
      },
      hiveId: {
        serializedName: "hiveId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      fullName: {
        serializedName: "fullName",
        required: true,
        type: {
          name: "String"
        }
      },
      documentId: {
        serializedName: "documentId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      revisionNumber: {
        serializedName: "revisionNumber",
        required: true,
        type: {
          name: "Number"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      primaryVariantTypeCode: {
        serializedName: "primaryVariantTypeCode",
        required: true,
        type: {
          name: "String"
        }
      },
      annotationTarget: {
        serializedName: "annotationTarget",
        type: {
          name: "Composite",
          className: "AnnotationTargetInfo"
        }
      },
      isAppealedLatestVerdict: {
        serializedName: "isAppealedLatestVerdict",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      attachments: {
        serializedName: "attachments",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AttachmentDto"
            }
          }
        }
      },
      variants: {
        serializedName: "variants",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "VariantInfo"
            }
          }
        }
      },
      familyName: {
        serializedName: "familyName",
        nullable: true,
        type: {
          name: "String"
        }
      },
      effectiveDate: {
        serializedName: "effectiveDate",
        nullable: true,
        type: {
          name: "DateTime"
        }
      }
    }
  }
};
exports.DocumentInfo = DocumentInfo;
var SchemaDrivenPropertyInfo = {
  type: {
    name: "Composite",
    className: "SchemaDrivenPropertyInfo",
    modelProperties: {
      outerXml: {
        constraints: {
          MinLength: 1
        },
        serializedName: "OuterXml",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.SchemaDrivenPropertyInfo = SchemaDrivenPropertyInfo;
var TaxonReferenceInfo = {
  type: {
    name: "Composite",
    className: "TaxonReferenceInfo",
    modelProperties: {
      hiveId: {
        serializedName: "HiveId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      taxonomyName: {
        serializedName: "TaxonomyName",
        required: true,
        type: {
          name: "String"
        }
      },
      taxonKey: {
        serializedName: "TaxonKey",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.TaxonReferenceInfo = TaxonReferenceInfo;
var AttachmentDto = {
  type: {
    name: "Composite",
    className: "AttachmentDto",
    modelProperties: {
      identifier: {
        serializedName: "identifier",
        required: true,
        type: {
          name: "String"
        }
      },
      blobId: {
        serializedName: "blobId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      mimeType: {
        serializedName: "mimeType",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      displayFileName: {
        serializedName: "displayFileName",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.AttachmentDto = AttachmentDto;
var VariantInfo = {
  type: {
    name: "Composite",
    className: "VariantInfo",
    modelProperties: {
      variantTypeCode: {
        serializedName: "VariantTypeCode",
        required: true,
        type: {
          name: "String"
        }
      },
      primaryParts: {
        serializedName: "PrimaryParts",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PrimaryPartInfo"
            }
          }
        }
      },
      supplementalParts: {
        serializedName: "SupplementalParts",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SupplementalPartInfo"
            }
          }
        }
      }
    }
  }
};
exports.VariantInfo = VariantInfo;
var PrimaryPartInfo = {
  type: {
    name: "Composite",
    className: "PrimaryPartInfo",
    modelProperties: {
      index: {
        serializedName: "Index",
        required: true,
        type: {
          name: "Number"
        }
      },
      mimeType: {
        serializedName: "MimeType",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.PrimaryPartInfo = PrimaryPartInfo;
var SupplementalPartInfo = {
  type: {
    name: "Composite",
    className: "SupplementalPartInfo",
    modelProperties: {
      name: {
        serializedName: "Name",
        required: true,
        type: {
          name: "String"
        }
      },
      mimeType: {
        serializedName: "MimeType",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.SupplementalPartInfo = SupplementalPartInfo;
var DocumentDto = {
  type: {
    name: "Composite",
    className: "DocumentDto",
    modelProperties: {
      properties: {
        serializedName: "properties",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentPropertyDto"
            }
          }
        }
      },
      taxons: {
        serializedName: "taxons",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentTaxonDto"
            }
          }
        }
      },
      hiveId: {
        serializedName: "hiveId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      fullName: {
        serializedName: "fullName",
        required: true,
        type: {
          name: "String"
        }
      },
      documentId: {
        serializedName: "documentId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      revisionNumber: {
        serializedName: "revisionNumber",
        required: true,
        type: {
          name: "Number"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      primaryVariantTypeCode: {
        serializedName: "primaryVariantTypeCode",
        required: true,
        type: {
          name: "String"
        }
      },
      annotationTarget: {
        serializedName: "annotationTarget",
        type: {
          name: "Composite",
          className: "AnnotationTargetInfo"
        }
      },
      isAppealedLatestVerdict: {
        serializedName: "isAppealedLatestVerdict",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      attachments: {
        serializedName: "attachments",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AttachmentDto"
            }
          }
        }
      },
      variants: {
        serializedName: "variants",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "VariantInfo"
            }
          }
        }
      },
      familyName: {
        serializedName: "familyName",
        nullable: true,
        type: {
          name: "String"
        }
      },
      effectiveDate: {
        serializedName: "effectiveDate",
        nullable: true,
        type: {
          name: "DateTime"
        }
      }
    }
  }
};
exports.DocumentDto = DocumentDto;
var DocumentPropertyDto = {
  type: {
    name: "Composite",
    className: "DocumentPropertyDto",
    modelProperties: {
      name: {
        constraints: {
          MinLength: 1
        },
        serializedName: "Name",
        required: true,
        type: {
          name: "String"
        }
      },
      value: {
        constraints: {
          MinLength: 1
        },
        serializedName: "Value",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.DocumentPropertyDto = DocumentPropertyDto;
var DocumentTaxonDto = {
  type: {
    name: "Composite",
    className: "DocumentTaxonDto",
    modelProperties: {
      taxonomyName: {
        serializedName: "TaxonomyName",
        required: true,
        type: {
          name: "String"
        }
      },
      taxonKey: {
        serializedName: "TaxonKey",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "Title",
        required: true,
        type: {
          name: "String"
        }
      },
      longTitle: {
        serializedName: "LongTitle",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.DocumentTaxonDto = DocumentTaxonDto;
var Toc = {
  type: {
    name: "Composite",
    className: "Toc",
    modelProperties: {
      entries: {
        serializedName: "entries",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TocEntry"
            }
          }
        }
      }
    }
  }
};
exports.Toc = Toc;
var TocEntry = {
  type: {
    name: "Composite",
    className: "TocEntry",
    modelProperties: {
      heading: {
        serializedName: "heading",
        required: true,
        type: {
          name: "String"
        }
      },
      target: {
        serializedName: "target",
        required: true,
        type: {
          name: "String"
        }
      },
      children: {
        serializedName: "children",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TocEntry"
            }
          }
        }
      }
    }
  }
};
exports.TocEntry = TocEntry;
var DocumentPropertyModel = {
  type: {
    name: "Composite",
    className: "DocumentPropertyModel",
    modelProperties: {
      namespaceName: {
        serializedName: "namespaceName",
        required: true,
        type: {
          name: "String"
        }
      },
      elementName: {
        serializedName: "elementName",
        required: true,
        type: {
          name: "String"
        }
      },
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.DocumentPropertyModel = DocumentPropertyModel;
var PrintRequestModel = {
  type: {
    name: "Composite",
    className: "PrintRequestModel",
    modelProperties: {
      annotationRequest: {
        serializedName: "annotationRequest",
        type: {
          name: "Composite",
          className: "AnnotationRequest"
        }
      },
      removedSectionIds: {
        serializedName: "removedSectionIds",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      lang: {
        serializedName: "lang",
        required: true,
        type: {
          name: "String"
        }
      },
      showAbstract: {
        serializedName: "showAbstract",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      showCoverPage: {
        serializedName: "showCoverPage",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      showTableOfContents: {
        serializedName: "showTableOfContents",
        required: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};
exports.PrintRequestModel = PrintRequestModel;
var AnnotationRequest = {
  type: {
    name: "Composite",
    className: "AnnotationRequest",
    modelProperties: {
      contextId: {
        serializedName: "ContextId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      contextType: {
        serializedName: "ContextType",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [0, 1]
        }
      }
    }
  }
};
exports.AnnotationRequest = AnnotationRequest;
var AboutDocumentFamilyDto = {
  type: {
    name: "Composite",
    className: "AboutDocumentFamilyDto",
    modelProperties: {
      fieldModels: {
        serializedName: "fieldModels",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentFieldModel"
            }
          }
        }
      },
      properties: {
        serializedName: "properties",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentFamilyPropertyDto"
            }
          }
        }
      }
    }
  }
};
exports.AboutDocumentFamilyDto = AboutDocumentFamilyDto;
var DocumentFieldModel = {
  type: {
    name: "Composite",
    className: "DocumentFieldModel",
    modelProperties: {
      fieldType: {
        serializedName: "fieldType",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["None", "Text", "Number", "Date", "Status", "Link", "FamilyStatus", "Boolean", "Classification"]
        }
      },
      label: {
        serializedName: "label",
        required: true,
        type: {
          name: "String"
        }
      },
      fieldName: {
        serializedName: "fieldName",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.DocumentFieldModel = DocumentFieldModel;
var DocumentFamilyPropertyDto = {
  type: {
    name: "Composite",
    className: "DocumentFamilyPropertyDto",
    modelProperties: {
      fieldName: {
        serializedName: "fieldName",
        required: true,
        type: {
          name: "String"
        }
      },
      fieldValue: {
        serializedName: "fieldValue",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.DocumentFamilyPropertyDto = DocumentFamilyPropertyDto;
var RelatedTargetDocumentFieldSetModel = {
  type: {
    name: "Composite",
    className: "RelatedTargetDocumentFieldSetModel",
    modelProperties: {
      fieldSet: {
        serializedName: "fieldSet",
        required: true,
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "any"
            }
          }
        }
      },
      targetsDocument: {
        serializedName: "targetsDocument",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      targetBookmarkIds: {
        serializedName: "targetBookmarkIds",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
exports.RelatedTargetDocumentFieldSetModel = RelatedTargetDocumentFieldSetModel;
var RelatedSourceDocumentFieldSetModel = {
  type: {
    name: "Composite",
    className: "RelatedSourceDocumentFieldSetModel",
    modelProperties: {
      fieldSet: {
        serializedName: "fieldSet",
        required: true,
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "any"
            }
          }
        }
      },
      targetsDocument: {
        serializedName: "targetsDocument",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      sourceBookmarkIds: {
        serializedName: "sourceBookmarkIds",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
exports.RelatedSourceDocumentFieldSetModel = RelatedSourceDocumentFieldSetModel;
var DocumentRelationNodeDto = {
  type: {
    name: "Composite",
    className: "DocumentRelationNodeDto",
    modelProperties: {
      documentProperties: {
        serializedName: "documentProperties",
        required: true,
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "any"
            }
          }
        }
      },
      children: {
        serializedName: "children",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentRelationNodeDto"
            }
          }
        }
      }
    }
  }
};
exports.DocumentRelationNodeDto = DocumentRelationNodeDto;
var RelatedTargetDocumentFieldSetsDto = {
  type: {
    name: "Composite",
    className: "RelatedTargetDocumentFieldSetsDto",
    modelProperties: {
      sourceDocumentId: {
        serializedName: "sourceDocumentId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      targets: {
        serializedName: "targets",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "RelatedTargetDocumentFieldSetModel"
            }
          }
        }
      }
    }
  }
};
exports.RelatedTargetDocumentFieldSetsDto = RelatedTargetDocumentFieldSetsDto;
var DocumentRelationsLocationsModel = {
  type: {
    name: "Composite",
    className: "DocumentRelationsLocationsModel",
    modelProperties: {
      documentHasRelations: {
        serializedName: "documentHasRelations",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      documentHasRelationsToTopOfDocument: {
        serializedName: "documentHasRelationsToTopOfDocument",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      bookmarkIds: {
        serializedName: "bookmarkIds",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
exports.DocumentRelationsLocationsModel = DocumentRelationsLocationsModel;
var RelationGroupDto = {
  type: {
    name: "Composite",
    className: "RelationGroupDto",
    modelProperties: {
      relationGroupName: {
        serializedName: "relationGroupName",
        required: true,
        type: {
          name: "String"
        }
      },
      relationGroupNameTranslationKey: {
        serializedName: "relationGroupNameTranslationKey",
        nullable: true,
        type: {
          name: "String"
        }
      },
      showHeader: {
        serializedName: "showHeader",
        nullable: true,
        type: {
          name: "Boolean"
        }
      },
      groups: {
        serializedName: "groups",
        nullable: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "RelationGroupDto"
            }
          }
        }
      },
      relations: {
        serializedName: "relations",
        nullable: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "RelatedDocumentDto"
            }
          }
        }
      },
      uniqueRelatedDocumentsCount: {
        serializedName: "uniqueRelatedDocumentsCount",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.RelationGroupDto = RelationGroupDto;
var RelatedDocumentDto = {
  type: {
    name: "Composite",
    className: "RelatedDocumentDto",
    modelProperties: {
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      hiveId: {
        serializedName: "hiveId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      fullName: {
        serializedName: "fullName",
        required: true,
        type: {
          name: "String"
        }
      },
      bookmarks: {
        serializedName: "bookmarks",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BookmarkDto"
            }
          }
        }
      },
      label: {
        serializedName: "label",
        nullable: true,
        type: {
          name: "String"
        }
      },
      date: {
        serializedName: "date",
        nullable: true,
        type: {
          name: "DateTime"
        }
      },
      hideDate: {
        serializedName: "hideDate",
        nullable: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};
exports.RelatedDocumentDto = RelatedDocumentDto;
var BookmarkDto = {
  type: {
    name: "Composite",
    className: "BookmarkDto",
    modelProperties: {
      isTopOfDocument: {
        serializedName: "isTopOfDocument",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      bookmark: {
        serializedName: "bookmark",
        nullable: true,
        type: {
          name: "String"
        }
      },
      bookmarkRank: {
        serializedName: "bookmarkRank",
        nullable: true,
        type: {
          name: "Number"
        }
      },
      bookmarkTitle: {
        serializedName: "bookmarkTitle",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.BookmarkDto = BookmarkDto;
var DocumentSectionDto = {
  type: {
    name: "Composite",
    className: "DocumentSectionDto",
    modelProperties: {
      sectionId: {
        serializedName: "sectionId",
        required: true,
        type: {
          name: "String"
        }
      },
      sectionTitle: {
        serializedName: "sectionTitle",
        required: true,
        type: {
          name: "String"
        }
      },
      children: {
        serializedName: "children",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSectionDto"
            }
          }
        }
      }
    }
  }
};
exports.DocumentSectionDto = DocumentSectionDto;
var DocumentSectionTreeDto = {
  type: {
    name: "Composite",
    className: "DocumentSectionTreeDto",
    modelProperties: {
      sections: {
        serializedName: "sections",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSectionDto"
            }
          }
        }
      }
    }
  }
};
exports.DocumentSectionTreeDto = DocumentSectionTreeDto;
var DocumentSubscriptionModel = {
  type: {
    name: "Composite",
    className: "DocumentSubscriptionModel",
    modelProperties: {
      subscriptionName: {
        serializedName: "subscriptionName",
        required: true,
        type: {
          name: "String"
        }
      },
      query: {
        serializedName: "query",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.DocumentSubscriptionModel = DocumentSubscriptionModel;
var DocumentSubscriptionMarksDelta = {
  type: {
    name: "Composite",
    className: "DocumentSubscriptionMarksDelta",
    modelProperties: {
      firstMarkId: {
        serializedName: "firstMarkId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      secondMarkId: {
        serializedName: "secondMarkId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      unchanged: {
        serializedName: "unchanged",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSubscriptionMarkDeltaItem"
            }
          }
        }
      },
      changed: {
        serializedName: "changed",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ChangedDocumentSubscriptionMarkDeltaItem"
            }
          }
        }
      },
      added: {
        serializedName: "added",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSubscriptionMarkDeltaItem"
            }
          }
        }
      },
      removed: {
        serializedName: "removed",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentSubscriptionMarkDeltaItem"
            }
          }
        }
      }
    }
  }
};
exports.DocumentSubscriptionMarksDelta = DocumentSubscriptionMarksDelta;
var DocumentSubscriptionMarkDeltaItem = {
  type: {
    name: "Composite",
    className: "DocumentSubscriptionMarkDeltaItem",
    modelProperties: {
      documentId: {
        serializedName: "documentId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      revisionNumber: {
        serializedName: "revisionNumber",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.DocumentSubscriptionMarkDeltaItem = DocumentSubscriptionMarkDeltaItem;
var ChangedDocumentSubscriptionMarkDeltaItem = {
  type: {
    name: "Composite",
    className: "ChangedDocumentSubscriptionMarkDeltaItem",
    modelProperties: {
      documentId: {
        serializedName: "documentId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      originalRevisionNumber: {
        serializedName: "originalRevisionNumber",
        required: true,
        type: {
          name: "Number"
        }
      },
      changedRevisionNumber: {
        serializedName: "changedRevisionNumber",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.ChangedDocumentSubscriptionMarkDeltaItem = ChangedDocumentSubscriptionMarkDeltaItem;
var DocumentSubscriptionMarkCreateModel = {
  type: {
    name: "Composite",
    className: "DocumentSubscriptionMarkCreateModel",
    modelProperties: {
      documentsCount: {
        serializedName: "documentsCount",
        required: true,
        type: {
          name: "Number"
        }
      },
      markId: {
        serializedName: "markId",
        required: true,
        type: {
          name: "Uuid"
        }
      }
    }
  }
};
exports.DocumentSubscriptionMarkCreateModel = DocumentSubscriptionMarkCreateModel;
var DocumentSubscriptionMarkModel = {
  type: {
    name: "Composite",
    className: "DocumentSubscriptionMarkModel",
    modelProperties: {
      markId: {
        serializedName: "markId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      createdAt: {
        serializedName: "createdAt",
        required: true,
        type: {
          name: "DateTime"
        }
      }
    }
  }
};
exports.DocumentSubscriptionMarkModel = DocumentSubscriptionMarkModel;
var DocumentModel = {
  type: {
    name: "Composite",
    className: "DocumentModel",
    modelProperties: {
      hiveId: {
        serializedName: "hiveId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      documentId: {
        serializedName: "documentId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      fullName: {
        serializedName: "fullName",
        required: true,
        type: {
          name: "String"
        }
      },
      documentKind: {
        serializedName: "documentKind",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Content", "Taxonomy", "RuleSet", "Template", "Merge"]
        }
      },
      currentRevision: {
        serializedName: "currentRevision",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.DocumentModel = DocumentModel;
var DocumentVersionSubscriptionInfo = {
  type: {
    name: "Composite",
    className: "DocumentVersionSubscriptionInfo",
    modelProperties: {
      frequency: {
        serializedName: "frequency",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [0, 1, 2, 3]
        }
      },
      suspended: {
        serializedName: "suspended",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      lastProcessedAt: {
        serializedName: "lastProcessedAt",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      deletedAt: {
        serializedName: "deletedAt",
        required: true,
        type: {
          name: "DateTime"
        }
      },
      emailAddress: {
        serializedName: "emailAddress",
        required: true,
        type: {
          name: "String"
        }
      },
      subscriptionId: {
        serializedName: "subscriptionId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      documentId: {
        serializedName: "documentId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.DocumentVersionSubscriptionInfo = DocumentVersionSubscriptionInfo;
var CreateOrUpdateDocumentVersionSubscriptionModel = {
  type: {
    name: "Composite",
    className: "CreateOrUpdateDocumentVersionSubscriptionModel",
    modelProperties: {
      frequency: {
        serializedName: "frequency",
        nullable: true,
        type: {
          name: "Enum",
          allowedValues: [0, 1, 2, 3]
        }
      },
      suspended: {
        serializedName: "suspended",
        nullable: true,
        type: {
          name: "Boolean"
        }
      },
      emailAddress: {
        serializedName: "emailAddress",
        nullable: true,
        type: {
          name: "String"
        }
      },
      subscriptionId: {
        serializedName: "subscriptionId",
        nullable: true,
        type: {
          name: "Uuid"
        }
      },
      documentId: {
        serializedName: "documentId",
        nullable: true,
        type: {
          name: "Uuid"
        }
      },
      hiveId: {
        serializedName: "hiveId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      fullName: {
        serializedName: "fullName",
        required: true,
        type: {
          name: "String"
        }
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.CreateOrUpdateDocumentVersionSubscriptionModel = CreateOrUpdateDocumentVersionSubscriptionModel;
var DocumentViewInfo = {
  type: {
    name: "Composite",
    className: "DocumentViewInfo",
    modelProperties: {
      documentViewName: {
        constraints: {
          MaxLength: 256
        },
        serializedName: "documentViewName",
        required: true,
        type: {
          name: "String"
        }
      },
      templateAssetPath: {
        constraints: {
          MaxLength: 256
        },
        serializedName: "templateAssetPath",
        required: true,
        type: {
          name: "String"
        }
      },
      documentFieldSetName: {
        constraints: {
          MaxLength: 50
        },
        serializedName: "documentFieldSetName",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.DocumentViewInfo = DocumentViewInfo;
var DocumentLinkInfo = {
  type: {
    name: "Composite",
    className: "DocumentLinkInfo",
    modelProperties: {
      fromEmail: {
        constraints: {
          MinLength: 1
        },
        serializedName: "fromEmail",
        required: true,
        type: {
          name: "String"
        }
      },
      fromName: {
        constraints: {
          MinLength: 1
        },
        serializedName: "fromName",
        required: true,
        type: {
          name: "String"
        }
      },
      toEmail: {
        constraints: {
          MinLength: 1
        },
        serializedName: "toEmail",
        required: true,
        type: {
          name: "String"
        }
      },
      toName: {
        constraints: {
          MinLength: 1
        },
        serializedName: "toName",
        required: true,
        type: {
          name: "String"
        }
      },
      message: {
        constraints: {
          MinLength: 1
        },
        serializedName: "message",
        required: true,
        type: {
          name: "String"
        }
      },
      link: {
        constraints: {
          MinLength: 1
        },
        serializedName: "link",
        required: true,
        type: {
          name: "String"
        }
      },
      language: {
        constraints: {
          MinLength: 1
        },
        serializedName: "language",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.DocumentLinkInfo = DocumentLinkInfo;
var PortalLocalizationModel = {
  type: {
    name: "Composite",
    className: "PortalLocalizationModel",
    modelProperties: {
      locale: {
        serializedName: "locale",
        required: true,
        type: {
          name: "String"
        }
      },
      isDefault: {
        serializedName: "isDefault",
        required: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};
exports.PortalLocalizationModel = PortalLocalizationModel;
var TileDto = {
  type: {
    name: "Composite",
    className: "TileDto",
    modelProperties: {
      columnCount: {
        serializedName: "columnCount",
        required: true,
        type: {
          name: "Number"
        }
      },
      typeName: {
        serializedName: "typeName",
        readOnly: true,
        nullable: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      heading: {
        serializedName: "heading",
        required: true,
        type: {
          name: "String"
        }
      },
      supportedLocales: {
        serializedName: "supportedLocales",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
exports.TileDto = TileDto;
var MergeDocumentViewModel = {
  type: {
    name: "Composite",
    className: "MergeDocumentViewModel",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      mergeSections: {
        serializedName: "mergeSections",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "MergeSectionViewModel"
            }
          }
        }
      },
      mergeType: {
        serializedName: "mergeType",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.MergeDocumentViewModel = MergeDocumentViewModel;
var MergeSectionViewModel = {
  type: {
    name: "Composite",
    className: "MergeSectionViewModel",
    modelProperties: {
      relativeMergeLocation: {
        serializedName: "relativeMergeLocation",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Before", "AfterBegin", "AfterHeading", "BeforeEnd", "After"]
        }
      },
      text: {
        serializedName: "text",
        required: true,
        type: {
          name: "String"
        }
      },
      targetElementId: {
        serializedName: "targetElementId",
        required: true,
        type: {
          name: "String"
        }
      },
      locationType: {
        serializedName: "locationType",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["Id", "Article", "Bookmark", "NettoIndex"]
        }
      },
      sectionId: {
        serializedName: "sectionId",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.MergeSectionViewModel = MergeSectionViewModel;
var SearchPageConfigurationModel = {
  type: {
    name: "Composite",
    className: "SearchPageConfigurationModel",
    modelProperties: {
      defaultSearchString: {
        serializedName: "defaultSearchString",
        required: true,
        type: {
          name: "String"
        }
      },
      searchTermsAnalyzers: {
        serializedName: "searchTermsAnalyzers",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SearchTermsAnalyzerModel"
            }
          }
        }
      }
    }
  }
};
exports.SearchPageConfigurationModel = SearchPageConfigurationModel;
var SearchTermsAnalyzerModel = {
  type: {
    name: "Composite",
    className: "SearchTermsAnalyzerModel",
    modelProperties: {
      criteriaProviderKey: {
        serializedName: "criteriaProviderKey",
        required: true,
        type: {
          name: "String"
        }
      },
      regex: {
        serializedName: "regex",
        required: true,
        type: {
          name: "String"
        }
      },
      replaceExpression: {
        serializedName: "replaceExpression",
        required: true,
        type: {
          name: "String"
        }
      },
      icon: {
        serializedName: "icon",
        required: true,
        type: {
          name: "String"
        }
      },
      color: {
        serializedName: "color",
        required: true,
        type: {
          name: "String"
        }
      },
      order: {
        serializedName: "order",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.SearchTermsAnalyzerModel = SearchTermsAnalyzerModel;
var DocumentPageConfigurationModel = {
  type: {
    name: "Composite",
    className: "DocumentPageConfigurationModel",
    modelProperties: {
      aboutDocumentConfiguration: {
        serializedName: "aboutDocumentConfiguration",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AboutDocumentModel"
            }
          }
        }
      },
      historyTimelineConfiguration: {
        serializedName: "historyTimelineConfiguration",
        type: {
          name: "Composite",
          className: "HistoryTimelineConfigurationModel"
        }
      },
      consolidationConfiguration: {
        serializedName: "consolidationConfiguration",
        type: {
          name: "Composite",
          className: "ConsolidationConfigModel"
        }
      }
    }
  }
};
exports.DocumentPageConfigurationModel = DocumentPageConfigurationModel;
var AboutDocumentModel = {
  type: {
    name: "Composite",
    className: "AboutDocumentModel",
    modelProperties: {
      conditionFieldName: {
        serializedName: "conditionFieldName",
        required: true,
        type: {
          name: "String"
        }
      },
      conditionFieldValue: {
        serializedName: "conditionFieldValue",
        required: true,
        type: {
          name: "String"
        }
      },
      fields: {
        serializedName: "fields",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentFieldModel"
            }
          }
        }
      }
    }
  }
};
exports.AboutDocumentModel = AboutDocumentModel;
var HistoryTimelineConfigurationModel = {
  type: {
    name: "Composite",
    className: "HistoryTimelineConfigurationModel",
    modelProperties: {
      relationTypeCodes: {
        serializedName: "relationTypeCodes",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      secondaryTitleFieldName: {
        serializedName: "secondaryTitleFieldName",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.HistoryTimelineConfigurationModel = HistoryTimelineConfigurationModel;
var ConsolidationConfigModel = {
  type: {
    name: "Composite",
    className: "ConsolidationConfigModel",
    modelProperties: {
      consolidationRelationTypeCode: {
        serializedName: "consolidationRelationTypeCode",
        required: true,
        type: {
          name: "String"
        }
      },
      paragraphConsolidationRelationTypeCode: {
        serializedName: "paragraphConsolidationRelationTypeCode",
        required: true,
        type: {
          name: "String"
        }
      },
      preparationRelationTypeCode: {
        serializedName: "preparationRelationTypeCode",
        required: true,
        type: {
          name: "String"
        }
      },
      proposedChangeToParagraphRelationTypeCode: {
        serializedName: "proposedChangeToParagraphRelationTypeCode",
        required: true,
        type: {
          name: "String"
        }
      },
      remarksOnRelationTypeCode: {
        serializedName: "remarksOnRelationTypeCode",
        required: true,
        type: {
          name: "String"
        }
      },
      consolidationTitleFieldName: {
        serializedName: "consolidationTitleFieldName",
        required: true,
        type: {
          name: "String"
        }
      },
      labelFieldsetField: {
        serializedName: "labelFieldsetField",
        type: {
          name: "Composite",
          className: "DocumentFieldModel"
        }
      },
      hiveIdFieldsetFieldName: {
        serializedName: "hiveIdFieldsetFieldName",
        required: true,
        type: {
          name: "String"
        }
      },
      fullNameFieldsetFieldName: {
        serializedName: "fullNameFieldsetFieldName",
        required: true,
        type: {
          name: "String"
        }
      },
      preparatoryWorkConditionFieldName: {
        serializedName: "preparatoryWorkConditionFieldName",
        required: true,
        type: {
          name: "String"
        }
      },
      preparatoryWorkConditionFieldValues: {
        serializedName: "preparatoryWorkConditionFieldValues",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
exports.ConsolidationConfigModel = ConsolidationConfigModel;
var ParagraphZoomQueryModel = {
  type: {
    name: "Composite",
    className: "ParagraphZoomQueryModel",
    modelProperties: {
      law: {
        serializedName: "law",
        type: {
          name: "Composite",
          className: "Law"
        }
      }
    }
  }
};
exports.ParagraphZoomQueryModel = ParagraphZoomQueryModel;
var Law = {
  type: {
    name: "Composite",
    className: "Law",
    modelProperties: {
      hiveId: {
        serializedName: "hiveId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      familyName: {
        serializedName: "familyName",
        required: true,
        type: {
          name: "String"
        }
      },
      paragraphId: {
        serializedName: "paragraphId",
        required: true,
        type: {
          name: "String"
        }
      },
      paragraphInTimes: {
        serializedName: "paragraphInTimes",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ParagraphInTime"
            }
          }
        }
      }
    }
  }
};
exports.Law = Law;
var ParagraphInTime = {
  type: {
    name: "Composite",
    className: "ParagraphInTime",
    modelProperties: {
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      lawTitleAtTheTime: {
        serializedName: "lawTitleAtTheTime",
        required: true,
        type: {
          name: "String"
        }
      },
      lawPopularTitleAtTheTime: {
        serializedName: "lawPopularTitleAtTheTime",
        nullable: true,
        type: {
          name: "String"
        }
      },
      portalDocumentContext: {
        serializedName: "portalDocumentContext",
        type: {
          name: "Composite",
          className: "PortalDocumentContext"
        }
      },
      effectiveDate: {
        serializedName: "effectiveDate",
        nullable: true,
        type: {
          name: "DateTime"
        }
      },
      repealed: {
        serializedName: "repealed",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      paragraphState: {
        serializedName: "paragraphState",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [0, 1, 2, 3, 4]
        }
      }
    }
  }
};
exports.ParagraphInTime = ParagraphInTime;
var PortalDocumentContext = {
  type: {
    name: "Composite",
    className: "PortalDocumentContext",
    modelProperties: {
      documentId: {
        serializedName: "documentId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      portalDocumentPath: {
        serializedName: "portalDocumentPath",
        required: true,
        type: {
          name: "String"
        }
      },
      hiveId: {
        serializedName: "hiveId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      fullName: {
        serializedName: "fullName",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.PortalDocumentContext = PortalDocumentContext;
var PortalConfigurationDto = {
  type: {
    name: "Composite",
    className: "PortalConfigurationDto",
    modelProperties: {
      portalId: {
        serializedName: "portalId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      portalProperties: {
        serializedName: "portalProperties",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PortalPropertyDto"
            }
          }
        }
      }
    }
  }
};
exports.PortalConfigurationDto = PortalConfigurationDto;
var PortalPropertyDto = {
  type: {
    name: "Composite",
    className: "PortalPropertyDto",
    modelProperties: {
      propertyName: {
        serializedName: "propertyName",
        required: true,
        type: {
          name: "String"
        }
      },
      value: {
        serializedName: "value",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.PortalPropertyDto = PortalPropertyDto;
var ProductModel = {
  type: {
    name: "Composite",
    className: "ProductModel",
    modelProperties: {
      productId: {
        serializedName: "productId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      description: {
        serializedName: "description",
        required: true,
        type: {
          name: "String"
        }
      },
      code: {
        serializedName: "code",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      ownerOrganizationIdentifier: {
        serializedName: "ownerOrganizationIdentifier",
        required: true,
        type: {
          name: "String"
        }
      },
      imageAltText: {
        serializedName: "imageAltText",
        required: true,
        type: {
          name: "String"
        }
      },
      productNavigationTaxonomyName: {
        serializedName: "productNavigationTaxonomyName",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.ProductModel = ProductModel;
var ProductDropdownModel = {
  type: {
    name: "Composite",
    className: "ProductDropdownModel",
    modelProperties: {
      code: {
        serializedName: "code",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      ownerOrganizationIdentifier: {
        serializedName: "ownerOrganizationIdentifier",
        required: true,
        type: {
          name: "String"
        }
      },
      productNavigationTaxonomyName: {
        serializedName: "productNavigationTaxonomyName",
        required: true,
        type: {
          name: "String"
        }
      },
      localDocumentTypeTaxonomyDisplayTitle: {
        serializedName: "localDocumentTypeTaxonomyDisplayTitle",
        nullable: true,
        type: {
          name: "String"
        }
      },
      localDocumentTypeTaxonomyId: {
        serializedName: "localDocumentTypeTaxonomyId",
        nullable: true,
        type: {
          name: "Uuid"
        }
      }
    }
  }
};
exports.ProductDropdownModel = ProductDropdownModel;
var ProductPageDto = {
  type: {
    name: "Composite",
    className: "ProductPageDto",
    modelProperties: {
      tiles: {
        serializedName: "tiles",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ITileDto"
            }
          }
        }
      },
      navigation: {
        serializedName: "navigation",
        type: {
          name: "Composite",
          className: "ProductPageNavigationDto"
        }
      }
    }
  }
};
exports.ProductPageDto = ProductPageDto;
var ITileDto = {
  type: {
    name: "Composite",
    className: "ITileDto",
    modelProperties: {
      columnCount: {
        serializedName: "columnCount",
        required: true,
        type: {
          name: "Number"
        }
      },
      typeName: {
        serializedName: "typeName",
        readOnly: true,
        nullable: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      heading: {
        serializedName: "heading",
        required: true,
        type: {
          name: "String"
        }
      },
      supportedLocales: {
        serializedName: "supportedLocales",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
exports.ITileDto = ITileDto;
var ProductPageNavigationDto = {
  type: {
    name: "Composite",
    className: "ProductPageNavigationDto",
    modelProperties: {
      showTaxonDocuments: {
        serializedName: "showTaxonDocuments",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      showEmptyTaxons: {
        serializedName: "showEmptyTaxons",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      showGraphicalNavigation: {
        serializedName: "showGraphicalNavigation",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      expandTaxonDocumentsToLevel: {
        serializedName: "expandTaxonDocumentsToLevel",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.ProductPageNavigationDto = ProductPageNavigationDto;
var SavedSearchQueryViewModel = {
  type: {
    name: "Composite",
    className: "SavedSearchQueryViewModel",
    modelProperties: {
      savedSearchQueryId: {
        serializedName: "savedSearchQueryId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      name: {
        constraints: {
          MinLength: 1
        },
        serializedName: "name",
        required: true,
        type: {
          name: "String"
        }
      },
      queryStringParams: {
        constraints: {
          MinLength: 1
        },
        serializedName: "queryStringParams",
        required: true,
        type: {
          name: "String"
        }
      },
      searchRequest: {
        serializedName: "searchRequest",
        required: true,
        type: {
          name: "any"
        }
      }
    }
  }
};
exports.SavedSearchQueryViewModel = SavedSearchQueryViewModel;
var SearchViewType = {
  type: {
    name: "Composite",
    className: "SearchViewType",
    modelProperties: {
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String"
        }
      },
      identifier: {
        serializedName: "identifier",
        required: true,
        type: {
          name: "String"
        }
      },
      templateName: {
        serializedName: "templateName",
        required: true,
        type: {
          name: "String"
        }
      },
      documentFieldSetName: {
        serializedName: "documentFieldSetName",
        required: true,
        type: {
          name: "String"
        }
      },
      priority: {
        serializedName: "priority",
        required: true,
        type: {
          name: "Number"
        }
      },
      defaultOrderingOption: {
        serializedName: "defaultOrderingOption",
        required: true,
        type: {
          name: "String"
        }
      },
      icon: {
        serializedName: "icon",
        required: true,
        type: {
          name: "String"
        }
      },
      flags: {
        serializedName: "flags",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      hidden: {
        serializedName: "hidden",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      defaultPageSize: {
        serializedName: "defaultPageSize",
        required: true,
        type: {
          name: "Number"
        }
      },
      orderingOptions: {
        serializedName: "orderingOptions",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "OrderingOption"
            }
          }
        }
      },
      portalColumnHighlights: {
        serializedName: "portalColumnHighlights",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
exports.SearchViewType = SearchViewType;
var OrderingOption = {
  type: {
    name: "Composite",
    className: "OrderingOption",
    modelProperties: {
      fieldName: {
        serializedName: "fieldName",
        required: true,
        type: {
          name: "String"
        }
      },
      displayName: {
        serializedName: "displayName",
        required: true,
        type: {
          name: "String"
        }
      },
      defaultDirectionDescending: {
        serializedName: "defaultDirectionDescending",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      allowDirectionChange: {
        serializedName: "allowDirectionChange",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      priority: {
        serializedName: "priority",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.OrderingOption = OrderingOption;
var SearchFilterGroupModel = {
  type: {
    name: "Composite",
    className: "SearchFilterGroupModel",
    modelProperties: {
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      icon: {
        serializedName: "icon",
        required: true,
        type: {
          name: "String"
        }
      },
      allowAnonymous: {
        serializedName: "allowAnonymous",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      isExpanded: {
        serializedName: "isExpanded",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      isHidden: {
        serializedName: "isHidden",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      searchFilters: {
        serializedName: "searchFilters",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SearchFilterModel"
            }
          }
        }
      }
    }
  }
};
exports.SearchFilterGroupModel = SearchFilterGroupModel;
var SearchFilterModel = {
  type: {
    name: "Composite",
    className: "SearchFilterModel",
    modelProperties: {
      typeName: {
        serializedName: "typeName",
        readOnly: true,
        nullable: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.SearchFilterModel = SearchFilterModel;
var SearchRefinementViewInfo = {
  type: {
    name: "Composite",
    className: "SearchRefinementViewInfo",
    modelProperties: {
      title: {
        serializedName: "Title",
        required: true,
        type: {
          name: "String"
        }
      },
      count: {
        serializedName: "Count",
        required: true,
        type: {
          name: "Number"
        }
      },
      taxonCriteria: {
        serializedName: "TaxonCriteria",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TaxonCriteria"
            }
          }
        }
      },
      viewName: {
        serializedName: "ViewName",
        required: true,
        type: {
          name: "String"
        }
      },
      sortKey: {
        serializedName: "SortKey",
        required: true,
        type: {
          name: "String"
        }
      },
      sortDescending: {
        serializedName: "SortDescending",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      titleResource: {
        serializedName: "TitleResource",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.SearchRefinementViewInfo = SearchRefinementViewInfo;
var TaxonCriteria = {
  type: {
    name: "Composite",
    className: "TaxonCriteria",
    modelProperties: {
      taxonomyName: {
        serializedName: "TaxonomyName",
        required: true,
        type: {
          name: "String"
        }
      },
      taxonKey: {
        serializedName: "TaxonKey",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.TaxonCriteria = TaxonCriteria;
var SearchResultsExportInfo = {
  type: {
    name: "Composite",
    className: "SearchResultsExportInfo",
    modelProperties: {
      query: {
        serializedName: "query",
        required: true,
        type: {
          name: "any"
        }
      },
      organizationName: {
        serializedName: "organizationName",
        required: true,
        type: {
          name: "String"
        }
      },
      userName: {
        serializedName: "userName",
        required: true,
        type: {
          name: "String"
        }
      },
      searchTerms: {
        serializedName: "searchTerms",
        nullable: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      statusLabels: {
        serializedName: "statusLabels",
        nullable: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      sortField: {
        serializedName: "sortField",
        nullable: true,
        type: {
          name: "String"
        }
      },
      sortDirection: {
        serializedName: "sortDirection",
        nullable: true,
        type: {
          name: "Enum",
          allowedValues: [0, 1]
        }
      },
      relatedDocuments: {
        serializedName: "relatedDocuments",
        nullable: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      taxons: {
        serializedName: "taxons",
        nullable: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TaxonSearchExportInfo"
            }
          }
        }
      }
    }
  }
};
exports.SearchResultsExportInfo = SearchResultsExportInfo;
var TaxonSearchExportInfo = {
  type: {
    name: "Composite",
    className: "TaxonSearchExportInfo",
    modelProperties: {
      taxonomyFilterKey: {
        serializedName: "taxonomyFilterKey",
        required: true,
        type: {
          name: "Enum",
          allowedValues: ["None", "Product", "DocumentType", "LocalDocumentType"]
        }
      },
      taxonTitlePath: {
        serializedName: "taxonTitlePath",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.TaxonSearchExportInfo = TaxonSearchExportInfo;
var SearchResponse = {
  type: {
    name: "Composite",
    className: "SearchResponse",
    modelProperties: {
      results: {
        serializedName: "Results",
        required: true,
        type: {
          name: "any"
        }
      },
      taxonomyMatch: {
        serializedName: "TaxonomyMatch",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SearchResultTaxonomyMatchInfo"
            }
          }
        }
      },
      totalCount: {
        serializedName: "TotalCount",
        required: true,
        type: {
          name: "Number"
        }
      },
      queryTime: {
        serializedName: "QueryTime",
        required: true,
        type: {
          name: "Number"
        }
      },
      refinements: {
        serializedName: "Refinements",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SearchRefinementViewInfo"
            }
          }
        }
      }
    }
  }
};
exports.SearchResponse = SearchResponse;
var SearchResultTaxonomyMatchInfo = {
  type: {
    name: "Composite",
    className: "SearchResultTaxonomyMatchInfo",
    modelProperties: {
      taxonomyName: {
        serializedName: "TaxonomyName",
        required: true,
        type: {
          name: "String"
        }
      },
      taxonCounts: {
        serializedName: "TaxonCounts",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TaxonCountInfo"
            }
          }
        }
      }
    }
  }
};
exports.SearchResultTaxonomyMatchInfo = SearchResultTaxonomyMatchInfo;
var TaxonCountInfo = {
  type: {
    name: "Composite",
    className: "TaxonCountInfo",
    modelProperties: {
      taxonKey: {
        serializedName: "TaxonKey",
        required: true,
        type: {
          name: "String"
        }
      },
      count: {
        serializedName: "Count",
        required: true,
        type: {
          name: "Number"
        }
      }
    }
  }
};
exports.TaxonCountInfo = TaxonCountInfo;
var SearchPreviewDto = {
  type: {
    name: "Composite",
    className: "SearchPreviewDto",
    modelProperties: {
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.SearchPreviewDto = SearchPreviewDto;
var SearchSubscriptionInfo = {
  type: {
    name: "Composite",
    className: "SearchSubscriptionInfo",
    modelProperties: {
      subscriptionId: {
        serializedName: "subscriptionId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      query: {
        serializedName: "query",
        required: true,
        type: {
          name: "any"
        }
      },
      emailAddress: {
        serializedName: "emailAddress",
        required: true,
        type: {
          name: "String"
        }
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String"
        }
      },
      frequency: {
        serializedName: "frequency",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [0, 1, 2, 3]
        }
      },
      frequencyDisplayName: {
        serializedName: "frequencyDisplayName",
        required: true,
        type: {
          name: "String"
        }
      },
      limit: {
        serializedName: "limit",
        required: true,
        type: {
          name: "Number"
        }
      },
      suspended: {
        serializedName: "suspended",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      confirmed: {
        serializedName: "confirmed",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      lastProcessedAt: {
        serializedName: "lastProcessedAt",
        required: true,
        type: {
          name: "DateTime"
        }
      }
    }
  }
};
exports.SearchSubscriptionInfo = SearchSubscriptionInfo;
var SearchSuggestionsProviderModel = {
  type: {
    name: "Composite",
    className: "SearchSuggestionsProviderModel",
    modelProperties: {
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String"
        }
      },
      color: {
        serializedName: "color",
        required: true,
        type: {
          name: "String"
        }
      },
      icon: {
        serializedName: "icon",
        required: true,
        type: {
          name: "String"
        }
      },
      maxItems: {
        serializedName: "maxItems",
        required: true,
        type: {
          name: "Number"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      payload: {
        serializedName: "payload",
        required: true,
        type: {
          name: "String"
        }
      },
      availableOnMobile: {
        serializedName: "availableOnMobile",
        required: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};
exports.SearchSuggestionsProviderModel = SearchSuggestionsProviderModel;
var SpaConfigDto = {
  type: {
    name: "Composite",
    className: "SpaConfigDto",
    modelProperties: {
      identifier: {
        serializedName: "identifier",
        required: true,
        type: {
          name: "String"
        }
      },
      isAuthenticated: {
        serializedName: "isAuthenticated",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      googleTagManagerId: {
        serializedName: "googleTagManagerId",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      portalId: {
        serializedName: "portalId",
        required: true,
        type: {
          name: "String"
        }
      },
      lastModifiedTag: {
        serializedName: "lastModifiedTag",
        required: true,
        type: {
          name: "String"
        }
      },
      displayName: {
        serializedName: "displayName",
        required: true,
        type: {
          name: "String"
        }
      },
      authenticatedHelpUrl: {
        serializedName: "authenticatedHelpUrl",
        required: true,
        type: {
          name: "String"
        }
      },
      anonymousHelpUrl: {
        serializedName: "anonymousHelpUrl",
        required: true,
        type: {
          name: "String"
        }
      },
      profileUrl: {
        serializedName: "profileUrl",
        required: true,
        type: {
          name: "String"
        }
      },
      resetPasswordUrl: {
        serializedName: "resetPasswordUrl",
        required: true,
        type: {
          name: "String"
        }
      },
      angularMaterialPrimaryColor: {
        serializedName: "angularMaterialPrimaryColor",
        required: true,
        type: {
          name: "String"
        }
      },
      anchorScrollYOffset: {
        serializedName: "anchorScrollYOffset",
        required: true,
        type: {
          name: "Number"
        }
      },
      defaultLanguage: {
        serializedName: "defaultLanguage",
        required: true,
        type: {
          name: "String"
        }
      },
      navbarElements: {
        serializedName: "navbarElements",
        required: true,
        type: {
          name: "String"
        }
      },
      showLogInBox: {
        serializedName: "showLogInBox",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      searchResultsPdfExportMaxResults: {
        serializedName: "searchResultsPdfExportMaxResults",
        required: true,
        type: {
          name: "Number"
        }
      },
      allowAnonymousAccess: {
        serializedName: "allowAnonymousAccess",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      bypassFrontPageAfterLogin: {
        serializedName: "bypassFrontPageAfterLogin",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      useAdvancedSendLinkForm: {
        serializedName: "useAdvancedSendLinkForm",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      documentTicketAccessEnabled: {
        serializedName: "documentTicketAccessEnabled",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      enableNewDesign: {
        serializedName: "enableNewDesign",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      rhinestoneTheme: {
        serializedName: "rhinestoneTheme",
        type: {
          name: "Composite",
          className: "RhinestoneThemeDto"
        }
      }
    }
  }
};
exports.SpaConfigDto = SpaConfigDto;
var RhinestoneThemeDto = {
  type: {
    name: "Composite",
    className: "RhinestoneThemeDto",
    modelProperties: {
      primaryColor: {
        serializedName: "primaryColor",
        required: true,
        type: {
          name: "String"
        }
      },
      secondaryColor: {
        serializedName: "secondaryColor",
        required: true,
        type: {
          name: "String"
        }
      },
      backgroundColor: {
        serializedName: "backgroundColor",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.RhinestoneThemeDto = RhinestoneThemeDto;
var Taxonomy = {
  type: {
    name: "Composite",
    className: "Taxonomy",
    modelProperties: {
      hiveId: {
        serializedName: "hiveId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      name: {
        serializedName: "name",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      children: {
        serializedName: "children",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Taxon"
            }
          }
        }
      },
      allTaxons: {
        serializedName: "allTaxons",
        readOnly: true,
        nullable: true,
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Composite",
              className: "Taxon"
            }
          }
        }
      },
      fullName: {
        serializedName: "fullName",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.Taxonomy = Taxonomy;
var Taxon = {
  type: {
    name: "Composite",
    className: "Taxon",
    modelProperties: {
      taxonomyTitle: {
        serializedName: "taxonomyTitle",
        readOnly: true,
        nullable: true,
        type: {
          name: "String"
        }
      },
      taxonomyName: {
        serializedName: "taxonomyName",
        readOnly: true,
        nullable: true,
        type: {
          name: "String"
        }
      },
      key: {
        serializedName: "key",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      longTitle: {
        serializedName: "longTitle",
        required: true,
        type: {
          name: "String"
        }
      },
      sortOption: {
        serializedName: "sortOption",
        nullable: true,
        type: {
          name: "Enum",
          allowedValues: ["None", "Manual", "Title"]
        }
      },
      sortDirection: {
        serializedName: "sortDirection",
        nullable: true,
        type: {
          name: "Enum",
          allowedValues: ["None", "Desc", "Asc"]
        }
      },
      path: {
        serializedName: "path",
        readOnly: true,
        nullable: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TaxonPathInfo"
            }
          }
        }
      },
      children: {
        serializedName: "children",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Taxon"
            }
          }
        }
      }
    }
  }
};
exports.Taxon = Taxon;
var TaxonPathInfo = {
  type: {
    name: "Composite",
    className: "TaxonPathInfo",
    modelProperties: {
      key: {
        serializedName: "key",
        required: true,
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      longTitle: {
        serializedName: "longTitle",
        required: true,
        type: {
          name: "String"
        }
      },
      taxonomyName: {
        serializedName: "taxonomyName",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.TaxonPathInfo = TaxonPathInfo;
var TicketInfo = {
  type: {
    name: "Composite",
    className: "TicketInfo",
    modelProperties: {
      expirationYears: {
        serializedName: "expirationYears",
        required: true,
        type: {
          name: "Number"
        }
      },
      expirationMonths: {
        serializedName: "expirationMonths",
        required: true,
        type: {
          name: "Number"
        }
      },
      expirationDays: {
        serializedName: "expirationDays",
        required: true,
        type: {
          name: "Number"
        }
      },
      documentVersionOption: {
        serializedName: "documentVersionOption",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [0, 1, 2]
        }
      },
      originalLink: {
        serializedName: "originalLink",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.TicketInfo = TicketInfo;
var TimelineStatusDto = {
  type: {
    name: "Composite",
    className: "TimelineStatusDto",
    modelProperties: {
      hasTimeline: {
        serializedName: "hasTimeline",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      isVersionedDocument: {
        serializedName: "isVersionedDocument",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      isVersionedDkLaw: {
        serializedName: "isVersionedDkLaw",
        required: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};
exports.TimelineStatusDto = TimelineStatusDto;
var DocumentHistoryTimelineDto = {
  type: {
    name: "Composite",
    className: "DocumentHistoryTimelineDto",
    modelProperties: {
      timeline: {
        serializedName: "timeline",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentHistoryTimelineNodeDto"
            }
          }
        }
      }
    }
  }
};
exports.DocumentHistoryTimelineDto = DocumentHistoryTimelineDto;
var DocumentHistoryTimelineNodeDto = {
  type: {
    name: "Composite",
    className: "DocumentHistoryTimelineNodeDto",
    modelProperties: {
      documentProperties: {
        serializedName: "documentProperties",
        required: true,
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "any"
            }
          }
        }
      },
      additionalChildren: {
        serializedName: "additionalChildren",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentHistoryTimelineNodeLeafDto"
            }
          }
        }
      },
      additionalAncestors: {
        serializedName: "additionalAncestors",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DocumentHistoryTimelineNodeLeafDto"
            }
          }
        }
      },
      hasMoreConnections: {
        serializedName: "hasMoreConnections",
        required: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};
exports.DocumentHistoryTimelineNodeDto = DocumentHistoryTimelineNodeDto;
var DocumentHistoryTimelineNodeLeafDto = {
  type: {
    name: "Composite",
    className: "DocumentHistoryTimelineNodeLeafDto",
    modelProperties: {
      documentProperties: {
        serializedName: "documentProperties",
        required: true,
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "any"
            }
          }
        }
      },
      hasMoreConnections: {
        serializedName: "hasMoreConnections",
        required: true,
        type: {
          name: "Boolean"
        }
      }
    }
  }
};
exports.DocumentHistoryTimelineNodeLeafDto = DocumentHistoryTimelineNodeLeafDto;
var LegalTimelineNodeDto = {
  type: {
    name: "Composite",
    className: "LegalTimelineNodeDto",
    modelProperties: {
      hiveId: {
        serializedName: "hiveId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      fullName: {
        serializedName: "fullName",
        required: true,
        type: {
          name: "String"
        }
      },
      documentId: {
        serializedName: "documentId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      },
      subTitle: {
        serializedName: "subTitle",
        required: true,
        type: {
          name: "String"
        }
      },
      status: {
        serializedName: "status",
        required: true,
        type: {
          name: "Enum",
          allowedValues: [0, 1, 2, 3, 4, 5]
        }
      }
    }
  }
};
exports.LegalTimelineNodeDto = LegalTimelineNodeDto;
var UserViewModel = {
  type: {
    name: "Composite",
    className: "UserViewModel",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String"
        }
      },
      displayName: {
        serializedName: "displayName",
        required: true,
        type: {
          name: "String"
        }
      },
      features: {
        serializedName: "features",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "FeatureViewModel"
            }
          }
        }
      },
      privileges: {
        serializedName: "privileges",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      },
      organizationIdentifier: {
        serializedName: "organizationIdentifier",
        required: true,
        type: {
          name: "String"
        }
      },
      organizationName: {
        serializedName: "organizationName",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.UserViewModel = UserViewModel;
var FeatureViewModel = {
  type: {
    name: "Composite",
    className: "FeatureViewModel",
    modelProperties: {
      featureId: {
        serializedName: "featureId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      title: {
        serializedName: "title",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};
exports.FeatureViewModel = FeatureViewModel;
var UserProfileDto = {
  type: {
    name: "Composite",
    className: "UserProfileDto",
    modelProperties: {
      portalId: {
        serializedName: "portalId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      profileId: {
        serializedName: "profileId",
        required: true,
        type: {
          name: "Uuid"
        }
      },
      displayName: {
        serializedName: "displayName",
        required: true,
        type: {
          name: "String"
        }
      },
      identityClaimValue: {
        serializedName: "identityClaimValue",
        required: true,
        type: {
          name: "String"
        }
      },
      hasEmailFromClaims: {
        serializedName: "hasEmailFromClaims",
        required: true,
        type: {
          name: "Boolean"
        }
      },
      emailAddresses: {
        serializedName: "emailAddresses",
        required: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  }
};
exports.UserProfileDto = UserProfileDto;
var PathsJ2FataApiPortalsPortalidAssetcollectionsAssetcollectionidFilePostRequestbodyContentMultipartFormDataSchema = {
  type: {
    name: "Composite",
    className: "PathsJ2FataApiPortalsPortalidAssetcollectionsAssetcollectionidFilePostRequestbodyContentMultipartFormDataSchema",
    modelProperties: {
      file: {
        serializedName: "file",
        type: {
          name: "Stream"
        }
      }
    }
  }
};
exports.PathsJ2FataApiPortalsPortalidAssetcollectionsAssetcollectionidFilePostRequestbodyContentMultipartFormDataSchema = PathsJ2FataApiPortalsPortalidAssetcollectionsAssetcollectionidFilePostRequestbodyContentMultipartFormDataSchema;